/* eslint-disable no-unused-vars */

import { jsPDF } from "jspdf";

import { obterDataFormatada } from "../../../../utils";
import { createHeaderSenado } from "../../../model/header";
import { createFooterSenado } from "../../../model/footer";

export function relatorioDeHistoricoSenado(ibp, historico, title) {


  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
  });

  createHeaderSenado(doc, title);

  doc.setFont("", "bold");
  doc.text(`TOMBAMENTO: ${ibp.numTombamento}`, 10, 40, null, null, "left");

  doc.text(
    `TOMBAMENTO SAMP: ${ibp.s_numTombAntigo}`,
    10,
    44,
    null,
    null,
    "left"
  );

  doc.text(`Nº SERIE: ${ibp.numSerie}`, 10, 48, null, null, "left");

  doc.text(
    `SITUAÇÃO: ${ibp.situacao === 1 ? "Ativo" : "Inativo"}`,
    10,
    52,
    null,
    null,
    "left"
  );

  doc.text(`Histórico:`, 10, 56, null, null, "left");


  doc.setFont("", "normal");

  const lines = doc.splitTextToSize(historico, doc.internal.pageSize.width - 20);
  const lineHeight = doc.getTextDimensions('text').h; 

  let y = 60; 

  lines.forEach(line => {
    if (y + lineHeight > doc.internal.pageSize.height - 10) {
      createFooterSenado(doc);

      doc.addPage(); 
      y = 20; 
    }
    doc.text(line, 10, y);
    y += lineHeight; 
  });

  createFooterSenado(doc);



  doc.save(`Relatório Histórico de Item Bem Permanente do Senado`);
}